import "./modal-form.scss";

import * as React from "react";
import { PropsWithChildren, useEffect, useState } from "react";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import close from "../../../assets/icons/close.svg";
import Contact from "../../../components/common/contact";

export interface PropsModal extends PropsWithChildren<any> {
  title: string;
  is_active: any;
}

const ModalForm: React.FC<PropsModal> = (props: PropsModal) => {
  const { title } = props;

  return (
    <div className={`o-contact-modal`}>
      <div className={"card-container"}>
        <div className={"m-header-modal"}>
          <h2 className={"m-card__title"}>{title}</h2>
          <img
            src={close}
            className={"a-close"}
            onClick={() => {
              props.is_active(false);
            }}
          />
        </div>
        <div className={"m-card m-card--contact-modal"}>
          <Contact />
        </div>
      </div>
    </div>
  );
};

export default ModalForm;
